import Vue from 'vue'
import Vue2Storage from 'vue2-storage'
Vue.use(Vue2Storage)
// Session Storage
let Stratagy = {
  session: 0,
  browser: 1
}

export const $Vue2Storage = new Vue({
  created () {
    this.$storage.setOptions({
      prefix: 'app_',
      driver: 'local',
      ttl: 60 * 60 * 24 * 10
    })
  },
  data () {
    return {
      // session 缓存
      session: {}
    }
  },
  methods: {
    // biz methods
    // 商品缓存 -- 到仓！
    set (storageEnum, key, value) {
      if (storageEnum.strategy === Stratagy.browser) {
        this.$storage.set(
          storageEnum + key,
          value
        )
      } else if (storageEnum.strategy === Stratagy.session) {
        this.session[storageEnum + key] = value
      }
    },

    get (storageEnum, key) {
      if (storageEnum.strategy === Stratagy.browser) {
        return this.$storage.get(storageEnum + key)
      } else if (storageEnum.strategy === Stratagy.session) {
        return this.session[storageEnum + key]
      }
    }

  }
})

export const StorageEnum = {
  Goods: { code: 'goodsNo_', strategy: Stratagy.browser },
  Suppiler: { code: 'suppiler_', strategy: Stratagy.browser },
  SysConfig: { code: 'sysConfig_', strategy: Stratagy.session },
  Version: { code: 'version_', strategy: Stratagy.session }
}
